jQuery(document).ready(function($) {
    //console.log('ACF Tick Labels script loaded');
    
    function updateTickLabels() {
        //console.log('updateTickLabels() called');
        
        // Debug: Check if inclusion_columns field exists
        var inclusionColumns = $('.acf-field[data-name="inclusion_columns"]');
        //console.log('Found inclusion_columns fields:', inclusionColumns.length);
        
        // Debug: Check all ACF fields on page
        var allAcfFields = $('.acf-field[data-name]');
        //console.log('All ACF fields found:', allAcfFields.length);
        allAcfFields.each(function() {
            //console.log('ACF field found:', $(this).attr('data-name'));
        });
        
        // Get all column heading inputs
        var columnHeadingInputs = $('.acf-field[data-name="inclusion_columns"] .acf-field[data-name="column_heading"] input');
        //console.log('Found column heading inputs:', columnHeadingInputs.length);
        
        columnHeadingInputs.each(function(index) {
            var headingValue = $(this).val();
            var tickFields = ['tick_one', 'tick_two', 'tick_three', 'tick_four'];
            
            //console.log('Column heading', index + 1, ':', headingValue);
            
            if (index < tickFields.length) {
                var newLabel = headingValue ? headingValue : tickFields[index].replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
                
                // Find the table column headers - try multiple selectors for different contexts
                var columnHeaders = $('.acf-field[data-name="inclusion_items"] thead th.acf-th[data-name="' + tickFields[index] + '"] label');
                
                // Fallback for block editor context
                if (columnHeaders.length === 0) {
                    columnHeaders = $('.acf-field[data-name="inclusion_items"] .acf-table thead th[data-name="' + tickFields[index] + '"] label');
                }
                
                // Another fallback for block editor
                if (columnHeaders.length === 0) {
                    columnHeaders = $('[data-name="inclusion_items"] th[data-name="' + tickFields[index] + '"] label');
                }
                //console.log('Found column headers for', tickFields[index], ':', columnHeaders.length);
                
                // Debug: Let's see what we're actually targeting
                //console.log('Looking for selector:', '.acf-field[data-name="inclusion_items"] thead th.acf-th[data-name="' + tickFields[index] + '"] label');
                
                // Update the column headers
                if (columnHeaders.length > 0) {
                    columnHeaders.text(newLabel);
                    //console.log('Updated', tickFields[index], 'column headers to:', newLabel);
                } else {
                    //console.log('No column headers found to update for', tickFields[index]);
                    
                    // Debug: Let's check if the table structure exists at all
                    var tableExists = $('.acf-field[data-name="inclusion_items"] thead').length;
                    //console.log('Table head exists:', tableExists);
                    
                    var allThElements = $('.acf-field[data-name="inclusion_items"] thead th.acf-th').length;
                    //console.log('All th.acf-th elements found:', allThElements);
                    
                    var specificTh = $('.acf-field[data-name="inclusion_items"] thead th.acf-th[data-name="' + tickFields[index] + '"]').length;
                    //console.log('Specific th for', tickFields[index], ':', specificTh);
                }
            }
        });
        
        // Alternative selectors to try
        //console.log('--- Alternative selector debugging ---');
        var altColumnInputs = $('input[name*="column_heading"]');
        //console.log('Alternative column heading inputs found:', altColumnInputs.length);
        
        var altTickLabels = $('label:contains("Tick")');
        //console.log('Labels containing "Tick":', altTickLabels.length);
        
        // Check for specific field keys
        var fieldKeyInputs = $('input[name*="field_68917cceb7908"]'); // column_heading field key
        //console.log('Inputs with column_heading field key:', fieldKeyInputs.length);
    }
    
    // Update on page load
    //console.log('Running updateTickLabels on page load');
    updateTickLabels();
    
    // Also try after ACF is fully loaded
    $(document).on('acf/setup_fields', function() {
        //console.log('ACF fields setup complete, running updateTickLabels');
        setTimeout(updateTickLabels, 100);
    });
    
    // Block editor specific triggers
    $(document).on('acf/ready', function() {
        //console.log('ACF ready event, running updateTickLabels');
        setTimeout(updateTickLabels, 200);
    });
    
    // Try after a longer delay for block editor
    setTimeout(function() {
        //console.log('Delayed updateTickLabels for block editor');
        updateTickLabels();
    }, 1000);
    
    // Update when column headings change
    $(document).on('input', '.acf-field[data-name="column_heading"] input', function() {
        //console.log('Column heading input detected');
        setTimeout(updateTickLabels, 100);
    });
    
    // Try alternative selector for input changes
    $(document).on('input', 'input[name*="column_heading"]', function() {
        //console.log('Alternative column heading input detected');
        setTimeout(updateTickLabels, 100);
    });
    
    // Update when new rows are added to inclusion_columns
    $(document).on('click', '.acf-field[data-name="inclusion_columns"] .acf-button[data-event="add-row"]', function() {
        //console.log('Add row button clicked for inclusion_columns');
        setTimeout(updateTickLabels, 500);
    });
    
    // Update when rows are removed from inclusion_columns
    $(document).on('click', '.acf-field[data-name="inclusion_columns"] .acf-button[data-event="remove-row"]', function() {
        //console.log('Remove row button clicked for inclusion_columns');
        setTimeout(updateTickLabels, 500);
    });
    
    // Update when inclusion_items rows are added
    $(document).on('click', '.acf-field[data-name="inclusion_items"] .acf-button[data-event="add-row"]', function() {
        //console.log('Add row button clicked for inclusion_items');
        setTimeout(updateTickLabels, 500);
    });
    
    // Generic ACF change detection
    $(document).on('change', '.acf-field input', function() {
        var fieldName = $(this).closest('.acf-field').attr('data-name');
        if (fieldName === 'column_heading') {
            //console.log('Generic ACF change detected for column_heading');
            setTimeout(updateTickLabels, 100);
        }
    });
});